enum RequestProblemCategory {
  ClientSide = 'client',
  ServerSide = 'server',
  Logic = 'Logic',
}

export { RequestProblemCategory };
